import axios from "../../axiosMiddleware/index";
import { api } from "../../apiendpoints/index";

const dashboardRequestConfig = {
  showGlobalLoader: false,
};

export const GetSSTeam = async () => {
  return axios.get(`${api.DASHBOARD.TEAM}`, dashboardRequestConfig);
};

export const GetRunningProjects = async () => {
  return axios.get(
    `${api.DASHBOARD.RUNNING_PROJECTS}`,
    dashboardRequestConfig
  );
};

export const GetNotification = async () => {
  return axios.get(
    `${api.DASHBOARD.GET_NOTIFICATIONS}`,
    dashboardRequestConfig
  );
};

export const GetTodayUpdates = (includeUpcoming = false) => {
  return axios.get(api.DASHBOARD.TODAY_UPDATES, {
    ...dashboardRequestConfig,
    params: {
      includeUpcoming,
    },
  });
};

export const GetUpcomingHolidays = () => {
  return axios.get(
    `${api.DASHBOARD.UPCOMING_HOLIDAYS}`,
    dashboardRequestConfig
  );
};

export const SetNotificationMode = async (mode) => {
  return axios.post(
    `${api.DASHBOARD.SET_NOTIFICATION_MODE}`,
    {
      notificationMode: mode,
    },
    dashboardRequestConfig
  );
};

export const ClaimNotificationAlert = async (data) => {
  return axios.post(
    `${api.DASHBOARD.CLAIM_NOTIFICATION_ALERT}`,
    data,
    dashboardRequestConfig
  );
};

export const MarkNotificationsSeen = async () => {
  return axios.post(
    `${api.DASHBOARD.MARK_NOTIFICATIONS_SEEN}`,
    undefined,
    dashboardRequestConfig
  );
};
